import { TrashCan } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const LeagueMembersRemoveDialog = makeConfirmActionDialog({
  mutationName: "leagueMembersRemove",
  paramName: "leagueMemberIds",
  action: "Remove",
  useButtonProps: () => {
    return {
      icon: <TrashCan />,
      content: "Remove",
    };
  },
});
